/**
 * @param {{
 *   caseStart: number
 *   baseInterval: 5 | 10
 *   cpTime: number
 *   vitalsDuration: number
 * }} param0
 * @returns {boolean}
 */
export const isRequiredCheckpoint = ({
  caseStart,
  baseInterval,
  cpTime,
  vitalsDuration,
}) => {
  const elapsed = cpTime - caseStart
  if (elapsed > vitalsDuration) return false
  return elapsed >= 0 && elapsed % (baseInterval * 60000) === 0
}
